import React, { useState, useRef, useEffect } from "react";
import PropTypes from 'prop-types';

const Share = ({ shareUrl, contentType, showIconOnly, showIconWithText, showIconWithButton, shareMessage, showDetails, privacyType }) => {
    let facebook, twitter, linkedin; 

    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef(null);
    const buttonRef = useRef(null);

    switch (privacyType) {
        case 'privatepost':
            facebook = false;
            twitter = false;
            linkedin = false;
            break;
        case 'privatelead':
        case 'privatelisting':
            facebook = false;
            twitter = false;
            linkedin = false;
            break;
        default:
            facebook = true;
            twitter = true;
            linkedin = true;
            break;
    }

    const encodedMessage = encodeURIComponent(shareMessage);

    const shareOptions = [
        facebook && {
            name: 'facebook',
            icon: 're-icon-facebook',
            url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`
        },
        twitter && {
            name: 'twitter',
            icon: 're-icon-twitter',
            url: `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodedMessage}`
        },
        linkedin && {
            name: 'linkedin',
            icon: 're-icon-linkedin',
            url: `https://www.linkedin.com/shareArticle?mini=true&text=${encodedMessage} ${encodeURIComponent(shareUrl)}`
        },
        {
            name: 'email',
            icon: 're-icon-email re-btn-black',
            url: `mailto:?subject=Check%20this%20out!&body=${encodedMessage}%20${encodeURIComponent(shareUrl)}`
        },
        {
            name: 'inbox',
            icon: 're-icon-comment',
            url: `${window.location.origin}/inbox?Message=${encodedMessage}%20${encodeURIComponent(shareUrl)}`
        }
    ].filter(Boolean); 

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div className="re-share-widget-container">
            {showIconOnly  ? <button
                ref={buttonRef}
                onClick={(e) => { e.preventDefault(); setIsOpen(!isOpen) }}
                title="share"
                data-testid="sharebtnicononly"
                className="re-icon re-icon-md re-icon-clockwise"
                data-share-type={privacyType}
            ></button>: null }
                        
            {showIconWithText ? <button
                ref={buttonRef}
                onClick={(e) => { e.preventDefault(); setIsOpen(!isOpen) }}
                data-testid="sharebtniconwithtext"
                className="re-btn re-btn-plain re-icon re-icon-xs re-icon-clockwise"
                data-share-type={privacyType}
            >
                share
            </button> : null}

            {showIconWithButton ? <button
                ref={buttonRef}
                onClick={(e) => { e.preventDefault(); setIsOpen(!isOpen) }}
                data-testid="sharebtniconwithbutton"
                className="re-icon re-icon-xs re-icon-clockwise re-icon-xs re-btn re-btn-small re-btn-white re-btn-full-width re-share-widget-button-item"
                data-share-type={privacyType}
            >
                Share
            </button> : null}

            {isOpen ? (
                <div ref={menuRef} className={`re-share-widget-options ${showIconWithText ? 're-share-widget-options-position' : ''} re-container re-container-sm re-container-outer`}>
                    <div className={`re-share-widget-arrow ${showIconWithText ? 're-share-widget-arrow-position' : ''}`}></div>
                    {shareOptions.map((option, index) => (
                        <a
                            key={index}
                            href={option.url}
                            target={option.name !== 'inbox' ? "_blank" : "_self"}
                            rel="noopener noreferrer"
                            className={`re-btn re-btn-round re-btn-round-small re-icon ${option.icon}`}
                            data-mixpanel-name="Intent"
                            data-mixpanel-type="share"
                            data-mixpanel-contenttype={contentType}
                            data-mixpanel-method={option.name}
                            data-testid={option.name}
                        >
                        </a>
                    ))}
                    {(showDetails && window.location.href !== shareUrl) ? <div className="re-share-permalink">
                        <a href={shareUrl} className="re-btn re-btn-small re-btn-cancel" title="View details" data-mixpanel-name="Intent" data-mixpanel-type="share" data-mixpanel-contenttype="post" data-mixpanel-method="permalink">
                            View details
                        </a>
                    </div> : null}
                </div>
            ) : null}
        </div>
    );
};


Share.propTypes = {
    shareUrl: PropTypes.string,
    contentType: PropTypes.string,
    showIconOnly: PropTypes.bool,
    showIconWithText: PropTypes.bool,
    showButton: PropTypes.bool,
    showDetails: PropTypes.bool
};

Share.defaultProps = {
    showIconOnly: false,
    showIconWithButton: false,
    showIconWithText: false,
    showDetails: false
};

export default Share;
